<template>
    <div class="circle-users">
        <div
            class="circle"
            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
            :content="`${item.user.name} (${item.user.status})`"
            v-for="item in getOrderedUsers()"
            :key="item.user._id"
            :class="{ selected: item.user._id === value }"
            @click="changeUser(item.user)"
        >
            <span v-if="item.badge || item.badge === 0" class="badge">{{ item.badge }}</span>
            <AgentAvatar :userID="item.user._id" :size="40" single-char />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import AgentAvatar from "../../../common/AgentAvatar.vue";

export default Vue.extend({
    name: "CircleUserSelect",
    components: { AgentAvatar },
    props: {
        users: {
            type: Array,
            required: true,
        },
        value: {
            type: String,
        },
        nullable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    methods: {
        getOrderedUsers() {
            return _.orderBy(this.users, ["user.name"], ["asc"]);
        },
        changeUser(user) {
            if (this.value === user._id && this.nullable) {
                this.$emit("input", null);
                return;
            }
            this.$emit("input", user._id);
        },
    },
});
</script>

<style lang="scss">
.circle-users {
    display: flex;
    flex-direction: row;
    gap: 3px;
    position: relative;

    .circle {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        opacity: 0.6;

        .badge {
            position: absolute;
            top: -5px;
            right: -5px;
            background-color: #22272d;
            color: white;
            border-radius: 50%;
            padding: 2px 5px;
            font-size: 12px;
            z-index: 999;
        }

        .vue-avatar--wrapper {
            background-color: rgb(181 181 195) !important;
            color: black !important;
            cursor: pointer;
        }

        &:hover {
            transform: scale(1.1);
        }

        &.selected {
            transform: scale(1.1);
            opacity: 1;

            .vue-avatar--wrapper {
                background-color: #32cd32 !important;
                color: white !important;
                cursor: pointer;
            }
        }
    }
}
</style>
